<template>
  <div> 
    <div class="md-layout">
      <div class="md-layout-item">
        <Authenticator/>
      </div>
    </div>
  </div>
</template>

<script>
import Authenticator from './../components/Authenticator'

export default {
  name: 'LoginPage',
  components: {
    Authenticator,
  },
  data: () => ({
      signedIn: false
  }),
  async beforeCreate() {
    try {
      await this.$Amplify.Auth.currentAuthenticatedUser();
      this.signedIn = true;
      this.$store.dispatch("tryAuthenticateUser")
      this.$router.push("/dashboard");
    } catch (err) {
      this.signedIn = false;
    }
  }
}
</script>

<style>
.nav {
  display: flex;
}
.nav p {
  padding: 0px 30px 0px 0px;
  font-size: 18px;
  color: #000;
}
.nav p:hover {
  opacity: .7;
}
.nav p a {
  text-decoration: none;
}
.sign-out {
  width: 160px;
  margin: 0 auto;
}
</style>
